import React from 'react';
import PropTypes from 'prop-types';
import ActiveAd from './ActiveAd';
import FollowButton from './FollowButton';
import i18n from '../../../shared/locales/no.json';
import * as actions from '../../actions/profileActions';
import analytics, * as trackingTypes from '../../actions/analyticsActions';
import { chain, uniq } from 'lodash';
import Optional from 'optional-js';

export default class AdCollection extends React.Component {
    constructor() {
        super();
        this.handleLinkClick = this.handleLinkClick.bind(this);
        this.scrollToAds = this.scrollToAds.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    componentDidMount() {
        setTimeout(this.scrollToAds);
    }

    handleLinkClick(adId, heading) {
        this.props.dispatch(
            analytics(trackingTypes.CLICK_ACTIVE_AD, { adId, heading })
        );
    }

    scrollToAds() {
        // We'll need this awful solution till react-router decides to support normal hash use.
        if (location.search.indexOf('activeAds') > -1) {
            Optional.ofNullable(this.activeAds).ifPresent((node) =>
                window.scrollTo(0, node.offsetTop - 55)
            );
        }
    }

    onChange(select) {
        this.props.dispatch(actions.filterCompanyAds(select.target.value));
    }

    getAdTypes(ads) {
        const types = ads.map((ad) => uniq(ad.type));
        return chain(types)
            .flatten()
            .countBy()
            .toPairs()
            .sortBy((pair) => (pair[0] === 'Annet' ? 0 : pair[1]))
            .reverse()
            .value();
    }

    render() {
        const { props } = this;
        const { ads, filter } = props.ads;
        return (
            <section
                className={this.props.className}
                id="activeAds"
                ref={(_ref) => {
                    this.activeAds = _ref;
                }}
            >
                <div className="panel">
                    <div className="form-grid">
                        <h2 className="form-grid__unit form-grid__unit--g1">
                            {i18n['Available positions']}
                        </h2>
                        <div className="form-grid__unit form-grid__unit--g0">
                            {!props.editMode && (
                                <FollowButton
                                    followCompany={props.followCompany}
                                    id="bottom"
                                />
                            )}
                        </div>
                    </div>
                </div>

                <div className="u-r-size1of2">
                    {ads.length > 0 && (
                        <div className="panel">
                            <div className="input input--select">
                                <label htmlFor="filterActiveAds">
                                    {i18n['Choose job type']}
                                </label>
                                <div className="input--select__wrap">
                                    <select
                                        name="filterActiveAds"
                                        onChange={this.onChange}
                                    >
                                        <option value="">
                                            {i18n['All job types']} (
                                            {ads.length})
                                        </option>
                                        {this.getAdTypes(ads).map(
                                            ([key, count]) => (
                                                <option key={key} value={key}>
                                                    {key} ({count})
                                                </option>
                                            )
                                        )}
                                    </select>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                <div className="grid t-grid grid--cols1to2">
                    {ads.length === 0 ? (
                        <div className="grid__unit u-r-size1of2">
                            <div className="panel">
                                {i18n['Your active ads will be present here']}
                            </div>
                        </div>
                    ) : (
                        ads.map((ad, i) =>
                            filter === '' || ad.type.indexOf(filter) !== -1 ? (
                                <ActiveAd
                                    {...ad}
                                    key={i}
                                    onLinkClick={this.handleLinkClick}
                                />
                            ) : null
                        )
                    )}
                </div>
            </section>
        );
    }
}

AdCollection.propTypes = {
    id: PropTypes.number,
    className: PropTypes.string,
    ads: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    profile: PropTypes.object.isRequired,
    editMode: PropTypes.bool.isRequired,
    followCompany: PropTypes.object.isRequired,
};

AdCollection.defaultProps = {
    profile: {},
};
